import Axios from 'axios';
import {DYNATRACE_BASE_URL, DYNATRACE_RUM_TOKEN, DYNATRACE_SAGESYNC_ID, IS_PRODUCTION} from '../config/constants';

export const getDynatraceRumTag = () => {
	const apiClient = Axios.create({
		baseURL: DYNATRACE_BASE_URL,
		headers: {
			'Content-Type': 'application/json; charset=utf-8',
			Authorization: DYNATRACE_RUM_TOKEN,
		},
	});

	if (IS_PRODUCTION) {
		return apiClient.get(`/api/v1/rum/jsTagComplete/${DYNATRACE_SAGESYNC_ID}`);
	}
};
